"use client";

import {
  PARTNER_REVEAL_MOTION_CLASS,
  PARTNER_REVEAL_STAGGER_MS,
  partnerColumnRevealStyle,
} from "@/components/partners/partner-column-reveal";
import { PartnerSiteLink } from "@/components/partners/partner-site-link";
import { ActionButton } from "@/components/ui/action-button";
import { useScrollAnimate } from "@/hooks/use-scroll-animate";
import Image from "next/image";

/** Set page for the Julia Robinson Mathematics Festival games. */
export const JRMF_GAMES_HREF = "/pages/julia-robinson-mathematics-festival";
export const JRMF_SITE_HREF = "https://jrmf.org/";

export function JrmfSection() {
  const textAnimate = useScrollAnimate();
  const imageAnimate = useScrollAnimate();

  return (
    <section className="bg-surface-50 py-12 md:py-16 lg:py-20" data-testid="jrmf-section">
      <div className="mx-auto max-w-[1024px] px-3 sm:px-4">
        <div className="flex flex-col items-center gap-8 md:flex-row md:gap-12">
          <div
            ref={textAnimate.ref}
            className={`w-full text-center md:w-2/5 md:text-left ${PARTNER_REVEAL_MOTION_CLASS}`}
            style={partnerColumnRevealStyle(textAnimate.isVisible, "left")}
          >
            <div className="mb-4">
              <Image
                src="/images/marketing/partners/jrmf/logo.svg"
                alt="Julia Robinson Mathematics Festival logo"
                width={360}
                height={115}
                className="inline-block h-12 w-auto md:h-16"
              />
            </div>
            <p className="mb-6 text-pretty text-base text-gray-700 md:text-lg">
              The Julia Robinson Mathematics Festival inspires joy with math through free festivals,
              family math nights, and hands-on puzzles. Kids explore open-ended problems together,
              without the pressure of competition.
            </p>
            <ActionButton href={JRMF_GAMES_HREF} variant="white">
              Play puzzles!
            </ActionButton>
            <div className="mt-6">
              <ActionButton href={JRMF_SITE_HREF}>Learn more</ActionButton>
            </div>
            <PartnerSiteLink href={JRMF_SITE_HREF} />
          </div>

          <div
            ref={imageAnimate.ref}
            className={`w-full md:w-3/5 ${PARTNER_REVEAL_MOTION_CLASS}`}
            style={partnerColumnRevealStyle(imageAnimate.isVisible, "right", {
              delayMs: PARTNER_REVEAL_STAGGER_MS,
            })}
          >
            <Image
              src="/images/marketing/partners/jrmf/festival.webp"
              alt="Families working on puzzles at a Julia Robinson Mathematics Festival"
              width={1024}
              height={576}
              className="h-auto w-full rounded-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
